import { render, staticRenderFns } from "./EditBasicDetailsAction.vue?vue&type=template&id=7f7b77c2&scoped=true&"
import script from "./EditBasicDetailsAction.vue?vue&type=script&lang=js&"
export * from "./EditBasicDetailsAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7b77c2",
  null
  
)

export default component.exports